<script>
  import { onMount } from "svelte";

  let emptyLegData = null;
  let visible = false;
  let loadError = false;

  async function getData() {
    let response = await fetch("https://api.jumphub.aero/stats/mapdata.php", {
      method: "GET",
      mode: "cors",
      cache: "default",
      headers: {
        "Content-Type": "application/json",
      },
    });

    let data = await response.json();
    return data;
  }

  onMount(async () => {
    try {
      emptyLegData = await getData();

      const map = new google.maps.Map(document.getElementById("jumphub-map"), {
        zoom: 3,
        center: { lat: 0, lng: -180 },
        mapTypeId: "terrain",
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        styles: [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#f5f5f5",
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#bdbdbd",
              },
            ],
          },
          {
            featureType: "poi",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "road",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#dadada",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "labels",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "transit",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#c9c9c9",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
        ],
      });

      var bounds = new google.maps.LatLngBounds();

      emptyLegData.flights.forEach((flight) => {
        const flightPath = new google.maps.Polyline({
          path: [flight[0].latlng, flight[1].latlng],
          geodesic: true,
          strokeColor: "#ff9900",
          strokeOpacity: 1,
          strokeWeight: 2,
        });

        flightPath.setMap(map);

        [0, 1].forEach((index) => {
          const marker = new google.maps.Marker({
            position: flight[index].latlng,
            label: {
              text: flight[index].code,
              color: "#063948",
              fontSize: "11px",
            },
            map: map,
            icon: {
              path: google.maps.SymbolPath.CIRCLE,
              scale: 0,
            },
          });

          bounds.extend(marker.position);
        });
      });

      map.fitBounds(bounds);
      visible = true;
    } catch (error) {
      loadError = true;
    }
  });
</script>

{#if !visible && !loadError}
  <div style="display: flex; justify-content: center; margin-top: 20px;">
    <div class="preloader-wrapper small active">
      <div class="spinner-layer spinner-green-only">
        <div class="circle-clipper left">
          <div class="circle" />
        </div>
        <div class="gap-patch">
          <div class="circle" />
        </div>
        <div class="circle-clipper right">
          <div class="circle" />
        </div>
      </div>
    </div>
  </div>
{/if}

{#if loadError}
  <div style="text-align: center; margin-top: 40px; text-transform: uppercase; font-size: 0.8em; color: orange;">An error occurred</div>
{/if}

<div class="jumphub-stats-wrapper" class:visible>
  <div class="jumphub-stats">
    <div class="jumphub-stat">
      <h3>T+7</h3>
      Days
    </div>

    <div class="jumphub-stat">
      <h3>{emptyLegData && emptyLegData.stats.flights}</h3>
      Empty legs
    </div>

    <div class="jumphub-stat">
      <h3>{emptyLegData && emptyLegData.stats.destinations}</h3>
      Destinations
    </div>
  </div>

  <div class="jumphub-map" id="jumphub-map" />

  <div class="jumphub-fineprint">Last updated {emptyLegData && emptyLegData.updated}</div>
</div>

<style>
  .visible {
    visibility: visible !important;
  }
  .jumphub-stats-wrapper {
    margin-top: 20px;
    text-align: center;
    color: #063948;
    visibility: hidden;
  }
  .jumphub-stats-wrapper .jumphub-stats {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    text-transform: uppercase;
    font-size: 9pt;
  }
  .jumphub-stats-wrapper .jumphub-stat h3 {
    font-size: 40pt;
    margin: 0 0 5px 0;
    font-weight: 200;
  }
  .jumphub-stats-wrapper .jumphub-map {
    width: 100%;
    height: 400px;
    background: #ccc;
    margin-top: 20px;
    border: solid 1px #ccc;
  }
  @media (min-width: 992px) {
    .jumphub-stats-wrapper .jumphub-map {
      height: 400px;
    }
  }
  @media (min-width: 1200px) {
    .jumphub-stats-wrapper .jumphub-map {
      height: 500px;
    }
  }
  .jumphub-stats-wrapper .jumphub-fineprint {
    font-size: 7pt;
    margin-top: 10px;
    text-transform: uppercase;
  }
</style>
